/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { environment as env } from '../../../environments/environment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationPreviewService {

  locationChange: Subject<any> = new Subject();

  getGoogleMap(options): string {
    return `https://maps.google.com/maps/api/staticmap?center=${options?.coords[0]},${options?.coords[1]}&zoom=${options?.zoom}&size=${options?.width}x${options?.height}&key=${env.googleMapKey}&markers=anchor:center|${options?.coords[0]},${options?.coords[1]}&scale=2`;
  }
  getHereMap(options): string {
    return `https://image.maps.api.here.com/mia/1.6/mapview?app_id=${env.hereKey.appID}&app_code=${env.hereKey.appCode}&style=fleet&i=1&z=${options?.zoom}&w=${options?.width}&h=${options?.height}&c=${options?.coords[0]},${options?.coords[1]}&u=100`;
  }
  displayOnGoogleMap(option): string {
    return `http://www.google.com/maps/place/${option?.coords[0]},${option?.coords[1]}`;
  }
  getGoogleIframe(options): string {
    return `https://maps.google.com/maps?ll=${options?.coords[0]},${(options?.coords[1] + 0.0300)}&width=${options?.width}&height=${options?.height}&hl=en&q=${options?.coords[0]},${options?.coords[1]}&t=&z=${options?.zoom}&ie=UTF8&iwloc=B&output=embed`;
    // return `https://www.google.com/maps/embed/v1/view?key=${env.googleMapKey}&center=${options?.coords[0]},${options?.coords[1]}&zoom=${options?.zoom}`;
  }
}
